import { toDateValue } from "./datetime";

const normalizeResourceUrl = (url) => {
  const value = `${url || ""}`.trim();
  if (!value) {
    return "";
  }

  try {
    const parsed = new URL(value);
    const cleanPath = parsed.pathname.replace(/\/+$/, "");
    return `${parsed.protocol}//${parsed.host}${cleanPath}${parsed.search}`.toLowerCase();
  } catch (error) {
    return value.replace(/\/+$/, "").toLowerCase();
  }
};

const hasResources = (lab) => Array.isArray(lab?.resources) && lab.resources.length > 0;

const getLabTimestamp = (lab) => {
  const date = toDateValue(lab?.dateTime);
  return date ? date.getTime() : 0;
};

const sortSessionsByDate = (left, right) => {
  const leftTime = getLabTimestamp(left);
  const rightTime = getLabTimestamp(right);
  return rightTime - leftTime;
};

export const getLabsWithResources = (labs = []) => {
  return [...labs].filter(hasResources).sort(sortSessionsByDate);
};

export const buildResourceSummary = (labs = []) => {
  const resourcesByUrl = new Map();
  const labsWithResources = getLabsWithResources(labs);

  labsWithResources.forEach((lab) => {
    lab.resources.forEach((resource) => {
      const normalizedUrl = normalizeResourceUrl(resource?.url);
      if (!normalizedUrl) {
        return;
      }

      const label = `${resource?.label || resource?.url || "Resource"}`.trim();
      const current = resourcesByUrl.get(normalizedUrl);

      const session = {
        labId: lab.id,
        labTitle: lab.title,
        dateTime: lab.dateTime,
      };

      if (!current) {
        resourcesByUrl.set(normalizedUrl, {
          id: normalizedUrl,
          url: `${resource.url}`.trim(),
          label,
          sessions: [session],
          lastUsedAtMs: getLabTimestamp(lab),
        });
        return;
      }

      current.sessions.push(session);
      current.lastUsedAtMs = Math.max(current.lastUsedAtMs, getLabTimestamp(lab));

      if (current.label.toLowerCase() === "resource" && label) {
        current.label = label;
      }
    });
  });

  const dedupedResources = Array.from(resourcesByUrl.values())
    .map((entry) => ({
      ...entry,
      sessions: entry.sessions.sort(sortSessionsByDate),
      usageCount: entry.sessions.length,
    }))
    .sort((left, right) => {
      if (right.lastUsedAtMs !== left.lastUsedAtMs) {
        return right.lastUsedAtMs - left.lastUsedAtMs;
      }

      return left.label.localeCompare(right.label);
    });

  return {
    dedupedResources,
    labsWithResources,
  };
};
